exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontStyle[data-v-268c323e]{font-size:12px}.errorStyle[data-v-268c323e]{font-weight:bolder;color:red}.card[data-v-268c323e]{background:#fff;border-radius:10px;transition:.3s ease-in-out}.card-body[data-v-268c323e]{padding:0!important}.card[data-v-268c323e]:hover{transform:translateY(-3px);box-shadow:0 4px 8px rgba(0,0,0,.2)}h6[data-v-268c323e]{margin-bottom:5px;color:#333}p[data-v-268c323e]{margin-bottom:10px;font-size:14px;color:#555}", ""]);

// exports
